import { ChevronLeft } from '@styled-icons/heroicons-outline/ChevronLeft';
import { ChevronRight } from '@styled-icons/heroicons-outline/ChevronRight';
import { ScrollButtonGroupSchema } from '@/views/sports/components/ScrollButtonGroup/styles/ScrollButtonGroup.styles';

export const scrollButtonGroupStyles: ScrollButtonGroupSchema = {
  iconButtonScrollRightSvg: {
    as: ChevronRight,
    sx: {
      boxSize: '4',
    },
  },
  iconButtonScrollRight: {
    bgGradient: 'linear(to-b, alpha.400, alpha.600)',
    color: 'white',
    borderRadius: 'sm',
    borderLeftRadius: 'none',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.3)',
    border: 'none',
    w: 'auto',
    minW: '4',
    _hover: {
      color: 'beta.500',
    },
    sx: {
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  iconButtonScrollLeftSvg: {
    as: ChevronLeft,
    sx: {
      boxSize: '4',
    },
  },
  iconButtonScrollLeft: {
    bgGradient: 'linear(to-b, alpha.400, alpha.600)',
    color: 'white',
    borderRadius: 'sm',
    borderRightRadius: 'none',
    textShadow: '0px 1px 0px rgba(255, 255, 255, 0.3)',
    border: 'none',
    w: 'auto',
    minW: '4',
    _hover: {
      color: 'beta.500',
    },
    sx: {
      ':active': {
        '&:after': {
          content: 'none',
        },
      },
    },
  },
  flexWrapper: {
    bg: 'blackAlpha.400',
    borderRadius: 'md',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.10), 0px 3px 5px 0px rgba(0, 0, 0, 0.20) inset',
  },
  buttonGroupSports: {
    display: 'inline-flex',
    flex: '1',
    bg: 'blackAlpha.400',
    overflowX: 'auto',
    p: '1',
    mr: [null, null, 2],
    spacing: '1',
    boxShadow:
      '0px 1px 0px 0px rgba(255, 255, 255, 0.1), 0px 3px 5px 0px rgba(0, 0, 0, 0.2) inset',
    whiteSpace: 'nowrap',
    pos: 'relative',
    w: ['120px', 'auto', null],
    borderRadius: [null, null, 'md'],
    inset: 0,
    right: [null, null, null, '38px'],
    alignItems: 'center',
    sx: {
      '::-webkit-scrollbar': { display: 'none' },
      button: {
        '-webkit-tap-highlight-color': 'transparent',
      },
    },
  },
  buttonGroupScrolls: {
    display: ['none', null, null, 'inline-flex'],
    pr: '2px',
    pos: 'relative',
    borderRadius: 'md',
    spacing: '1',
    ml: 'auto',
    gap: 0.5,
    isAttached: true,
  },
  scrollIndicator: {
    w: 2,
    h: '0.5',
    bg: 'beta.400',
    pos: 'absolute',
    bottom: 'px',
    transition: 'all 0.2s ease',
  },
};
